export function deepClone(object: unknown): unknown {
    return JSON.parse(JSON.stringify(object));
}
